import { useState, useEffect } from 'react'
import { api } from 'core/api/ConnectionManager'
import translate from 'core/translate'

const initialMemoryStatsState = {
    memory: [
        {
            label: 'space',
            origLabel: 'space',
            value: 0,
        },
    ],
    totalDiskSpace: 0,
    usageDiskSpace: 0,
    isLoaded: false,
    storageInfo: {
        storageId: '0',
        type: '',
        params: {
            endpoint: '',
            region: '',
            bucketName: '',
        },
    },
}

export interface MemoryItem {
    label: string
    origLabel: string
    value: number
}

export interface DashboardMemoryData {
    memory: MemoryItem[]
    totalDiskSpace: number
    usageDiskSpace: number
    isLoaded: boolean
    storageInfo: {
        storageId: string
        type: string
        params: {
            endpoint?: string
            region?: string
            bucketName?: string
        }
    }
}

interface DiskUsageStatsResponse {
    usage: Record<string, number>
    availableDiskSpace?: number
    totalDiskSpace?: number
}

type StorageInfoResponse = DashboardMemoryData['storageInfo']

function DashboardMemoryMethods() {
    const [data, setData] = useState<DashboardMemoryData>(initialMemoryStatsState)

    useEffect(() => {
        let componentIsMounted = true

        getInfo()

        async function getInfo() {
            const res = await api.send<object, DiskUsageStatsResponse>('getDiskUsageStats', {})

            if (!componentIsMounted) {
                return
            }

            const memory = Object.entries(res.usage).map(([key, value]) => ({
                label: translate(key),
                origLabel: key,
                value,
            }))
            const usageDiskSpace = memory.reduce((total, item) => total + item.value, 0)

            memory.push({
                origLabel: 'free',
                label: translate('free'),
                value: res.availableDiskSpace || 0,
            })

            setData({
                memory,
                totalDiskSpace: res.totalDiskSpace || 0,
                usageDiskSpace,
                isLoaded: true,
                storageInfo: {
                    storageId: '0',
                    type: 'local',
                    params: {
                        endpoint: '',
                        region: '',
                        bucketName: '',
                    },
                },
            })

            const storageInfo = await api.send<object, StorageInfoResponse>('getStorageInfo', {})

            if (componentIsMounted) {
                setData((prevState) => ({
                    ...prevState,
                    storageInfo,
                }))
            }
        }

        return () => {
            componentIsMounted = false
        }
    }, [])

    return {
        s_: {
            data,
        },
    }
}

export default DashboardMemoryMethods
